import React from "react";
import Content from "./components/content";
import Search from "./components/search";

const Stakeholder = () => {
  return (
    <>
      <Search />
      <Content />
    </>
  );
};

export default Stakeholder;
